export default __webpack_public_path__ + "static/media/blog-img223.7b4e9ce0.jpg";